import React from "react"
import PropTypes from "prop-types"
// Styles
import { Container, Wrapper } from "./Grid.styles"

const Grid = ({ header, children }) => (
    <Container>
        <h1>{header}</h1>
        <Wrapper>{children}</Wrapper>
    </Container>
)

Grid.propTypes = {
    header: PropTypes.string
}

export default Grid